// extracted by mini-css-extract-plugin
export default {"h1":"OrderCalc_h1__gEHwS","borderTop":"OrderCalc_borderTop__2cn2i","depthMove":"OrderCalc_depthMove__jlol1"};